import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Search from '@mui/icons-material/Search';
import TrendingUp from '@mui/icons-material/TrendingUp';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const queries = ['Abogados en Caracas', 'Asistencia legal Distrito Capital', 'Ética y familia', 'Colegio de Abogados DC'];

const DigestSeo = () => {
  const theme = useTheme();
  const h = readableHeading(theme);
  const deep = theme.palette.primary.main;
  const gold = theme.palette.secondary.main;

  return (
    <Box component="section" sx={{ my: { xs: 4, md: 6 } }}>
      <Grid container spacing={0} sx={{ borderRadius: 3, overflow: 'hidden', border: `1px solid rgba(196,164,93,0.38)` }}>
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            background: `linear-gradient(160deg, ${deep} 0%, ${theme.palette.primary.dark} 50%, #0c1612 100%)`,
            color: '#fff',
            position: 'relative',
            p: { xs: 3, sm: 4 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: { md: 280 },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              opacity: 0.15,
              backgroundImage: `repeating-linear-gradient(-12deg, transparent, transparent 18px, rgba(196,164,93,0.35) 18px, rgba(196,164,93,0.35) 19px)`,
              pointerEvents: 'none',
            }}
          />
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <TrendingUp sx={{ color: gold, fontSize: 28 }} />
              <Typography variant="overline" sx={{ color: gold, fontWeight: 800, letterSpacing: '0.2em' }}>
                TNO Digest
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: '3.25rem', sm: '4rem' },
                  fontWeight: 800,
                  lineHeight: 1,
                  color: gold,
                  fontFamily: 'Georgia, serif',
                  letterSpacing: '-0.03em',
                }}
              >
                2
              </Typography>
              <Typography component="span" sx={{ fontSize: '1.25rem', fontWeight: 600, color: 'rgba(255,255,255,0.9)' }}>
                artículos / semana
              </Typography>
            </Box>
            <Typography variant="h6" sx={{ mt: 1.5, fontWeight: 600, color: 'rgba(255,255,255,0.88)', maxWidth: 280 }}>
              8 piezas al mes pensadas para buscadores y reputación institucional.
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={7}
          sx={{
            bgcolor: theme.palette.mode === 'dark' ? 'rgba(21,37,30,0.55)' : '#fafbf9',
            p: { xs: 3, sm: 4 },
            position: 'relative',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 2 }}>
            <Search sx={{ color: gold, fontSize: 28, mt: 0.25 }} />
            <Box>
              <Typography variant="h5" component="h2" sx={{ fontWeight: 800, color: h, fontFamily: 'Georgia, serif', lineHeight: 1.25 }}>
                Autoridad donde la gente busca
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mt: 1.5, lineHeight: 1.75 }}>
                Cada publicación refuerza al Colegio como referencia cuando la ciudadanía explora temas legales, familia y
                confianza profesional. No es texto de relleno: es <strong>SEO editorial</strong> con voz gremial.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            {queries.map((q) => (
              <Chip
                key={q}
                label={q}
                size="small"
                sx={{
                  fontWeight: 600,
                  border: `1px solid rgba(196,164,93,0.45)`,
                  bgcolor: theme.palette.mode === 'dark' ? 'rgba(196,164,93,0.1)' : 'rgba(196,164,93,0.14)',
                  color: h,
                  '& .MuiChip-label': { px: 1.25 },
                }}
              />
            ))}
          </Box>

          <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.7, fontStyle: 'italic' }}>
            Pocos gremios combinan constancia en medios con piezas optimizadas para Google: aquí el Colegio ocupa ese espacio
            junto a <strong>Legalmente en Familia</strong>.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DigestSeo;
